// カレンダー編集画面のタブの値
export const CALENDAR_EDIT_TAB_VALUE = {
  JAPANESE: '日本語',
  ENGLISH: '英語',
} as const;

export type TabValue = typeof CALENDAR_EDIT_TAB_VALUE[keyof typeof CALENDAR_EDIT_TAB_VALUE];
